// THIS FILE IS AUTOMATICALLY GENERATED IN:
//
//   build-utils/update-file-index.js
//
// YOU SHOULD NEVER UPDATE THIS FILE DIRECTLY

import MapComponent from './MapComponent.vue'

// Export components individually
export { MapComponent }

// What should happen if the user installs the library as a plugin
function install(Vue) {
  Vue.component('MapComponent', MapComponent)
}

// Export the library as a plugin
export default { install: install }



// WEBPACK FOOTER //
// ./demo/components/map-component/src/index.js